'use strict';

var Backbone = require('backbone');
var $ = require('jquery');
var _ = require('underscore');

var polyglot = require('../../utilities/polyglot').default;

export default Backbone.View.extend({

  tagName: 'ul',
  className: 'toggle',
  events: {
    'click li a': 'onClick',
  },

  initialize: function (fromMapView) {
    this.active = fromMapView ? 1 : 0;

    this.tabs = [
      {
        container: '.l-location-step-search-and-list',
        label: polyglot.t('location.list'),
      },
      {
        container: '.l-location-step-map',
        label: polyglot.t('location.map'),
      },
    ];
  },

  isVisible: function () {
    return this.$el.is(':visible');
  },

  render: function () {
    this.$el.empty();

    var tab;
    for (var i = 0; i < this.tabs.length; i++) {
      tab = $('<li><a href="#">' + this.tabs[i].label + '</a></li>')
          .appendTo(this.$el);
      if (i == this.active) {
        tab.addClass('active');
        this.showTab(i);
      } else {
        this.hideTab(i);
      }
    }

    return this;
  },

  showTab: function(index) {
    if (index === 1) {
      $(this.tabs[index].container).css('visibility', 'visible');
    }
    $(this.tabs[index].container).show();
  },

  hideTab: function(index) {
    if (index === 1) {
      $(this.tabs[index].container).css('visibility', 'hidden');
    } else {
      $(this.tabs[index].container).hide();
    }
  },

  onClick: function (evt) {
    evt.preventDefault();
    var $el = $(evt.target);

    this.$('li').removeClass('active');
    $el.closest('li').addClass('active');

    for (var i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].label == $el.text()) {
        this.showTab(i);
      } else {
        this.hideTab(i);
      }
    }

    this.trigger('toggle', $el.text());
  },

  getTab: function (label) {
    for (var i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].label == label) {
        return this.tabs[i];
      }
    }

    return null;
  },

});
